import { apiHolder } from 'api';
import { useEffect } from 'react';
const watermarkID = 'watermark-fhergfhrehferhfehfehfu';
const eventApi = apiHolder.api.getEventApi();
const systemApi = apiHolder.api.getSystemApi();
import debounce from 'lodash/debounce';
const debounceWatermarkChanged = debounce(ev => {
    var _a;
    if (ev && ev.eventData) {
        const { show, markDetail, color, density, densityBase } = ev.eventData;
        if (show) {
            const watermarkData = {
                id: watermarkID,
                text: markDetail || '',
                color,
                density,
                densityBase,
            };
            if ((_a = window) === null || _a === void 0 ? void 0 : _a.watermarkObj) {
                if (document.getElementById(watermarkID)) {
                    window.watermarkObj.removeWatermark(watermarkID);
                    window.watermarkObj.watermark(watermarkData);
                }
                else {
                    window.watermarkObj.watermark(watermarkData);
                }
                return;
            }
            const j = document.createElement('script');
            j.async = true;
            j.src = 'https://mail.qiye.163.com/static/mimg/external/lib/watermark.min.js';
            if (!(document === null || document === void 0 ? void 0 : document.body))
                return;
            document.body.appendChild(j);
            j.onload = () => {
                var _a;
                if ((_a = window) === null || _a === void 0 ? void 0 : _a.watermarkObj) {
                    window.watermarkObj.watermark(watermarkData);
                }
            };
        }
        else {
            const watermarkDom = document.getElementById(watermarkID);
            if (watermarkDom) {
                window.watermarkObj.removeWatermark(watermarkID);
            }
        }
    }
}, 1500, {
    leading: false,
    trailing: true,
});
const useWatermark = () => {
    useEffect(() => {
        setTimeout(() => {
            systemApi.getAndCheckWatermark().then(res => {
                if (!res)
                    return;
                const { show, markDetail, color, density, densityBase } = res;
                if (show) {
                    const j = document.createElement('script');
                    j.async = true;
                    j.src = 'https://mail.qiye.163.com/static/mimg/external/lib/watermark.min.js';
                    if (!(document === null || document === void 0 ? void 0 : document.body))
                        return;
                    document.body.appendChild(j);
                    j.onload = () => {
                        var _a;
                        if ((_a = window) === null || _a === void 0 ? void 0 : _a.watermarkObj) {
                            if (document.getElementById(watermarkID))
                                return;
                            window.watermarkObj.watermark({
                                id: watermarkID,
                                text: markDetail || '',
                                color,
                                density,
                                densityBase,
                            });
                        }
                    };
                }
            });
        }, 1000);
    }, []);
    useEffect(() => {
        const id = eventApi.registerSysEventObserver('watermarkChanged', {
            func: ev => {
                debounceWatermarkChanged(ev);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('watermarkChanged', id);
        };
    }, []);
};
export default useWatermark;
